import { CircularProgress } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React, { useEffect } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { CSSTransition } from "react-transition-group";

const useStyles = makeStyles((theme) => ({
  progress: {
    margin: "auto",
  },
}));

export default function CircularIndeterminate() {
  const classes = useStyles();

  return (
    <div>
      <CircularProgress className={classes.progress} color="secondary" />
    </div>
  );
}
export function DashboardLoadingDialog() {
  const loading_state = useSelector((state) => {
    return state.dashboard.loading_state;
  }, shallowEqual);
  return <></>;
}

export const Loader2 = (props) => {
  const loading_states = useSelector((state) => {
    return state.dashboard.loading_states;
  });
  useEffect(() => {
    if (props.parent)
      props.parent.toggleEnterState(
        loading_states[props.resource] !== "loaded"
      );
  }, [loading_states]);

  return (
    <>
      {loading_states[props.resource] !== "loaded" && (
        <div className={` stack-box stack-top ${props.extraClasses}`}>
          <div
            className={`hide stack-box stack-top ${props.extraClasses}`}
            style={{ background: "transparent" }}
          ></div>
          <div
            className="stack-box stack-top2ss"
            style={{ display: "flex", justifyContent: "center" }}
          >
            <div
              className="loader2"
              style={{
                backgroundColor: "transparent",
                padding2: "10px",
                borderRadius: "1rem",
              }}
            >
              <div
                className="loader2-spinner cc"
                style={{
                  backgroundColor: "white",
                  padding2: "10px",
                  borderRadius: "1rem",
                }}
              >
                <div className="loader2-spinner2">
                  <CircularIndeterminate />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

const Fader = ({ children, ...props }) => (
  <CSSTransition {...props} timeout={1000} classNames="fade">
    {children}
  </CSSTransition>
);

export class Loader2mm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      in: false,
      addons: [],
    };
    this.toggleEnterState = this.toggleEnterState.bind(this);
  }

  toggleEnterState() {
    this.setState({ in: !this.state.in });
  }

  onEntered() {
    this.setState({ entered: true });
  }

  onExited() {
    this.setState({ entered: false });
  }

  render() {
    return (
      <div>
        <Fader
          key="first"
          in={this.state.in}
          onEntered={this.onEntered.bind(this)}
          onExited={this.onExited.bind(this)}
          className={`stack-box stack-top ${this.props.extraClasses} ${
            this.state.entered ? "entered" : ""
          }`}
        >
          <div>
            <Loader2
              parent={this}
              resource={this.props.resource}
              extraClasses={this.props.extraClasses}
            />
          </div>
        </Fader>
      </div>
    );
  }
}
